module.exports = __webpack_public_path__ + "static/media/favorites_counter.2593205b.svg";